import { resolveApiBaseUrls, type ApiBaseUrls, type ApiEnvironment, type ApiOwner } from './apiConfigValidation';

export { resolveApiBaseUrls } from './apiConfigValidation';
export type { ApiBaseUrls, ApiEnvironment, ApiOwner } from './apiConfigValidation';

let testApiBases: ApiBaseUrls | undefined;

/** Explicit test-only injection; application code must use Vite environment variables. */
export function setApiBaseUrlsForTest(environment?: ApiEnvironment): void {
    testApiBases = environment ? resolveApiBaseUrls(environment) : undefined;
}

export function apiUrl(owner: ApiOwner, path: string): string {
    if (!path.startsWith('/')) {
        throw new Error(`API path must start with '/': ${path}`);
    }
    // Vite replaces these literal property reads at build time. Keep build-time
    // validation in vite.config.ts; do not ship the cross-environment hostname
    // allowlist in the browser bundle where contamination scans would correctly
    // see inactive PROD hosts in a DEV artifact (and vice versa).
    const bases = testApiBases ?? {
        auth: import.meta.env.VITE_AUTH_API_URL,
        files: import.meta.env.VITE_FILES_API_URL,
        mgmt: import.meta.env.VITE_MGMT_API_URL,
    };
    return `${bases[owner]}${path}`;
}
